import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyChooseSection = () => {
  const valueProps = [
    {
      id: 1,
      icon: 'Globe',
      iconColor: 'text-blue-600',
      title: 'Global Service Delivery',
      description: 'Seamless operations management for international businesses across UK, US, Canada, UAE, and India.'
    },
    {
      id: 2,
      icon: 'TrendingDown',
      iconColor: 'text-green-600',
      title: '25% Cost Reduction',
      description: 'Reduce operational expenses through optimized international processes and transparent multi-currency billing.'
    },
    {
      id: 3,
      icon: 'Users',
      iconColor: 'text-purple-600',
      title: 'International Expertise',
      description: 'Access to skilled professionals with cross-border business experience and cultural understanding.'
    },
    {
      id: 4,
      icon: 'Shield',
      iconColor: 'text-red-600',
      title: '24×7 Global Support',
      description: 'Around-the-clock monitoring and support across time zones ensuring uninterrupted operations worldwide.'
    },
    {
      id: 5,
      icon: 'BarChart3',
      iconColor: 'text-orange-600',
      title: 'Real-Time Analytics',
      description: 'Detailed reporting and analytics accessible from anywhere to track global performance and identify improvements.'
    },
    {
      id: 6,
      icon: 'Zap',
      iconColor: 'text-cyan-600',
      title: 'Scalable Global Solutions',
      description: 'Flexible services that grow with your international business needs across multiple countries and locations.'
    }
  ];

  const statistics = [
    {
      id: 1,
      value: '500+',
      label: 'Global Enterprises Served',
      color: 'text-blue-600'
    },
    {
      id: 2,
      value: '99.9%',
      label: 'Uptime Guarantee',
      color: 'text-green-600'
    },
    {
      id: 3,
      value: '25+',
      label: 'Countries Covered',
      color: 'text-purple-600'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Global Businesses Choose ZippyAssist
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
            Trusted by international companies in UK, US, Canada, UAE for operational excellence with significant cost reduction and efficiency improvements.
          </p>
        </div>

        {/* Value Propositions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
          {valueProps?.map((prop) => (
            <div key={prop?.id} className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm hover:shadow-md transition-shadow">
              <div className={`w-14 h-14 rounded-lg bg-muted flex items-center justify-center mb-4 ${prop?.iconColor}`}>
                <Icon name={prop?.icon} size={28} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">{prop?.title}</h3>
              <p className="text-base text-muted-foreground">{prop?.description}</p>
            </div>
          ))}
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {statistics?.map((stat) => (
            <div key={stat?.id} className="bg-card rounded-xl p-8 text-center border border-border shadow-sm">
              <div className={`text-5xl md:text-6xl font-bold mb-3 ${stat?.color}`}>
                {stat?.value}
              </div>
              <div className="text-lg text-muted-foreground">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;